(function ($) {
	const blockSlug = 'productscarousel';
	const initializeBlock = function () {
	console.log(blockSlug);
		$('.acf-block-productscarousel').each(function(){
			// START your JS code
			const $block = $(this)
			const blockId = $block.attr('id');
			const blockData = $block;
			const swiperAutoplay = $block.find('.products-carousel-wrapper').data('swiper-autoplay');
			console.log('blockid: ' + blockId );
			console.log('blockData: ' + blockData );
			const swiper = new Swiper('#'+ blockId + ' .products-carousel-wrapper', {
				// Optional parameters
				loop: true,
				slidesPerView: 'auto',
				spaceBetween: 0,
				watchOverflow: false,
				keyboard: {
					enabled: true,
					onlyInViewport: false,
				},
				autoplay: {
					delay: swiperAutoplay,
				},
				pauseOnMouseEnter: true,
				navigation: {
					nextEl: '#'+ blockId + '-next',
					prevEl: '#'+ blockId + '-prev'
				}
			});

			if(swiperAutoplay > 0){
				swiper.autoplay.start();
			} else {
				swiper.autoplay.stop();
			}
			// END your JS code
		});
	};

	// Initialize each block on page load (front end).
	$(document).ready(function () {
		//$('.acf-block-' + blockSlug).each(function () {
			initializeBlock();
		//});
	});



	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=' + blockSlug, initializeBlock());
	}
})(jQuery);
